import { FormTemplate } from '@src/core';

const Collect3Form: FormTemplate = {
  title: 'Questionário Puérpera',
  subtitle: 'Questionário 3: de 40 a 45 dias pós-parto',
  initialMessage:
    'Olá! Esperamos que você esteja bem! <br/><br/>  Primeiramente, obrigado por estar dedicando mais um tempo para nos ajudar com a pesquisa! <br/><br/>  Como na etapa anterior, faremos novamente perguntas sobre seu processo de recuperação. Algumas perguntas podem parecer familiares, pois são essenciais para compreendermos sua evolução ao longo deste período que marca o término da <b>quarentena</b>.  Por favor, selecione as respostas que mais fielmente representam seu estado atual, especialmente em relação à recuperação na área com pontos onde você foi suturada.<br/><br/>Durante as questões, você notará que mencionaremos a palavra "DOR" algumas vezes. Sempre que isso ocorre, estamos nos referindo a qualquer tipo de desconforto ou sensação incômoda associada aos pontos no períneo/vagina.<br/><br/>  Vamos lá?',
  endedMessage:
    'Muito obrigado por ter respondido nossa pesquisa do projeto PEARLS! 🤩 <br/><br/>Sua ajuda faz toda a diferença para nós e para muitas outras mulheres.',
  step: {
    title: 'Avaliação',
    questions: {
      question01: {
        sequence: 1,
        type: 'radio',
        label: '1. Como você diria que está se sentindo fisicamente?',
        options: ['Muito Bem', 'Razoavelmente bem', 'Não muito bem', 'Nada bem'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question02: {
        sequence: 2,
        type: 'checkbox',
        label:
          '2. Nas últimas 24 horas, você precisou fazer uso de algum método para aliviar dor ou desconforto dos pontos?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Precisei procurar ajuda em um hospital',
          'Utilizei métodos naturais que foram suficientes',
          'Utilizei analgésico que tenho em casa',
          'Não foi necessário uso de métodos para alívio da dor',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question03: {
        sequence: 3,
        type: 'radio',
        label: '3. Como você descreveria a intensidade da dor ou desconforto?',
        options: ['Nenhuma', 'Leve', 'Moderado', 'Grave'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question04: {
        sequence: 4,
        type: 'radio',
        label: '4. Se existe dor ou desconforto, qual a frequência?',
        options: ['Pouco frequente', 'Quase sempre', 'Sempre'],
        validator: {
          dataType: 'string',
          required: false,
        },
        fullWidth: true,
      },

      question05: {
        sequence: 5,
        layout: '4-column',
        type: 'checkbox',
        label:
          '5. Marque quantas palavras abaixo melhor descrevem a sensação de dor ou desconforto que você sentiu na área onde foi suturada/com pontos nas últimas 24 horas.',
        options: [
          'ardente',
          'beliscando',
          'coçando',
          'cortante',
          'dor aguda',
          'dor contínua',
          'dor forte',
          'dor leve',
          'dor moderada',
          'estirando/repuxando',
          'formigando',
          'pinicando',
          'pontada',
          'torturante',
          'outros',
        ],
        validator: {
          dataType: 'array',
          required: false,
        },
        fullWidth: true,
        requestDetail: {
          label: 'Para "outros", por favor descreva:',
          conditions: [{ condition: 'outros' }],
        },
        isRequestDetailOther: true,
      },

      question06: {
        sequence: 6,
        type: 'radio-matrix',
        label:
          '6. Nas últimas 24 horas, quanta dor ou desconforto você sentiu na área onde foi suturada/com pontos ao fazer as seguintes atividades:',
        helperText: '',
        options: ['Nenhum', 'Leve', 'Moderado', 'Grave'],
        criteria: [
          'Alimentar seu bebê',
          'Andar certa de 100m',
          'Ficar em pé',
          'Sentar-se',
          'Deitada na cama',
          'Ao subir e descer da cama',
          'Ao se curvar ou abaixar',
          'Ao trocar o bebê',
          'Carregar seu bebê',
          'Fazer trabalho doméstico',
          'Ao urinar',
          'Ao evacuar',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question07: {
        sequence: 7,
        type: 'checkbox',
        label: '7. Você:',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Olhou para o seu períneo/vagina usando um espelho',
          'Sentiu o períneo/vagina com a mão',
          'Pediu para um familiar olhar seu períneo/vagina',
          'Não olhou ou sentiu o períneo/vagina',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question08: {
        sequence: 8,
        type: 'radio',
        label: '8. Depois de olhar a área onde você foi suturada/com pontos:',
        options: [
          'Parecia ou teve a sensação de estar MELHOR do que você pensava',
          'Parecia ou teve a sensação de estar PIOR do que você pensava',
          'Não conseguiu ver ou sentir',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question09: {
        sequence: 9,
        type: 'radio',
        label: '9. Você acha que seu períneo/vagina está cicatrizando? Sente-se "de volta ao normal"?',
        options: [
          'Sinto que meu períneo/vagina está cicatrizado, está de volta ao normal',
          'Sinto que meu períneo/vagina está cicatrizando bem, está quase de volta ao normal',
          'Sinto que meu períneo/vagina cicatrizou, porém, ficou com menor elasticidade e não está de volta ao normal',
          'Sinto que meu períneo/vagina está cicatrizando muito mal, longe de voltar ao normal',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question10: {
        sequence: 10,
        type: 'radio',
        label: '10. Após <b>12 dias da alta</b>, você teve alguma infecção na área onde foi suturada/com pontos?',
        options: [
          'Sim, precisei ir ao hospital e eles refizeram os pontos',
          'Sim, a infecção foi confirmada por um exame com o cotonete passado no corte',
          'Acho que sim, utilizei métodos naturais em casa que foram suficientes',
          'Sim, fui ao hospital e precisei apenas utilizar antibiótico',
          'Não tive infecção',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        requestDetail: {
          label:
            'Se a resposta foi "Sim, precisei ir ao hospital e eles refizeram os pontos", informe com quantos dias',
          conditions: [{ condition: 'Sim, precisei ir ao hospital e eles refizeram os pontos' }],
        },
      },

      question11: {
        sequence: 11,
        type: 'checkbox',
        label: '11. Você experimentou algum dos seguintes sintomas AO URINAR após a alta hospitalar?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Vazamento de urina ao tossir ou espirrar (incontinência de estresse)',
          'Urina com frequência durante o dia (mais de 7 vezes)',
          'Urina com frequência durante a noite (mais de 2 vezes)',
          'Não conseguiu esperar até chegar ao banheiro para urinar',
          'Ficou com incontinência urinária (sem saber que precisava urinar)',
          'Não sentiu nenhum desses sintomas desde o nascimento do seu bebê',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question12: {
        sequence: 12,
        type: 'checkbox',
        label: '12. Você experimentou algum dos seguintes sintomas AO EVACUAR após a alta hospitalar?',
        helperText: '(marque todas as opções aplicáveis)',
        options: [
          'Ciente de que precisa evacuar, mas incapaz de esperar até chegar ao banheiro',
          'Não sentiu vontade de evacuar, resultando em incontinência de fezes',
          'Presenciou sujeira ou manchas em sua roupa íntima com evacuações',
          'Sentiu dor ao evacuar',
          'Incapaz de controlar a eliminação de gases/pum pelo ânus',
          'Não experimentou nenhum sintoma',
        ],
        validator: {
          dataType: 'array',
          required: true,
          min: { value: 1, errorMessage: 'Selecione pelo menos UMA opção' },
        },
        fullWidth: true,
      },

      question13: {
        sequence: 13,
        type: 'radio',
        label: '13. Voltou a usar calças justas? Marque o grau de dor na região do períneo/vagina:',
        options: ['Nenhum', 'Leve', 'Moderado', 'Grave', 'Não tentei'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },

      question14: {
        sequence: 14,
        type: 'radio',
        label: '14. Conseguiu retomar a atividade sexual sem dor à penetração?',
        options: [
          'Consegui, não senti dor',
          'Não realizei tentativa',
          'Tentei, porém, senti muita dor',
          'Consegui, porém, senti dor moderada',
          'Consegui, senti pouca dor',
        ],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
        requestDetail: {
          label: 'Se a resposta foi "Não realizei tentativa", descreva o motivo',
          conditions: [{ condition: 'Não realizei tentativa' }],
        },
      },

      question15: {
        sequence: 15,
        type: 'radio',
        label: '15. Antes de engravidar, sentia dor durante as relações sexuais?',
        options: ['Nenhuma', 'Leve', 'Moderada', 'Intensa', 'Às vezes', 'Sempre'],
        validator: {
          dataType: 'string',
          required: true,
        },
        fullWidth: true,
      },
    },
  },
};

export { Collect3Form };
